import React, { ReactElement } from 'react';
import { LayoutScreenConfig, ScreenType } from '../../config/FlowTypes';
import { PaddedAccentContainer as PaddedContainer } from '../styles/ColoredContainers';
import { ScreenWrapper } from '../styles/Containers';
import { BodySM } from '../styles/Typography';
import { NavigationProps } from './FlowNavigation';
import { PresentationLayout, PresentationLayoutConfig } from './layouts/PresentationLayout';

type ProgramBenefitsLayoutConfig = {
  title?: string;
  content: PresentationLayoutConfig['content'];
  highlightCard?: string;
  primaryButtonTitle: string;
};

export type ProgramBenefitsScreenConfig<ScreenNames extends string> = LayoutScreenConfig<
  ScreenType.ProgramBenefits,
  ProgramBenefitsLayoutConfig,
  ScreenNames
>;

type ProgramBenefitsScreenProps<ScreenNames extends string> = NavigationProps<
  ProgramBenefitsScreenConfig<ScreenNames>,
  ScreenNames
>;

export const ProgramBenefitsScreen = <ScreenNames extends string>(
  props: ProgramBenefitsScreenProps<ScreenNames>
): ReactElement => {
  const { navigation, layout } = props;

  function contentToDisplay() {
    const content = [...layout.content];

    if (layout.highlightCard !== undefined) {
      content.push({
        type: 'custom',
        content: (
          <PaddedContainer center>
            <BodySM style={{ marginBottom: 0 }}>{layout.highlightCard}</BodySM>
          </PaddedContainer>
        ),
      });
    }
    return content;
  }

  return (
    <ScreenWrapper>
      <PresentationLayout
        title={layout.title}
        content={contentToDisplay()}
        primaryButtonTitle={layout.primaryButtonTitle}
        onPressPrimaryButton={() => navigation.next(props)}
      />
    </ScreenWrapper>
  );
};
